import { IonicModule } from "@ionic/angular";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppTranslateModule } from "src/app/services/i18n/translate.module";
import { CfImageDirectiveModule } from "src/app/directives/cf-image/cf-image.module";

import { InfoComponent } from "./info.component";

@NgModule({
  imports: [IonicModule, CommonModule, AppTranslateModule, CfImageDirectiveModule],
  declarations: [InfoComponent],
  exports: [InfoComponent],
})
export class InfoComponentModule {}
